$(function () {
    $('.multiSelect').multiSelect();
 });
 
 // NAVBAR Transition
 const body = document.body;
 let lastScroll = 0;
 
 window.addEventListener('scroll', () => {
     const currentScroll = window.pageYOffset;
     if (currentScroll <= 0){
         body.classList.remove('scrolldown');
     }
     if(currentScroll > lastScroll && !body.classList.contains("scrolldown")){
         body.classList.remove('scrollup');
         body.classList.add('scrolldown');
     }
     if(currentScroll < lastScroll && !body.classList.contains("scrolldown")){
         body.classList.add('scrollup');
         body.classList.remove('scrolldown');
     }
 
     lastScroll = currentScroll;
 });
 
 
 // Page Refresh
 window.addEventListener('load', function() {
     window.scrollBy(0, -50);
 });

 
